import { environment } from '../../../environments/environment';
import { Observable, BehaviorSubject, of, throwError } from 'rxjs';
import { Component, Injectable } from '@angular/core';

import { IUserInfo } from './user-info.model';
import { IAccess } from './access.model';
import { HttpService } from './http.service';
import { tap, map, mergeMap, catchError } from 'rxjs/operators';

@Injectable()
export class AuthService {
    API_URL: string;
    ENV: string;
    accessDetails: IAccess = new IAccess();
    
    constructor(private _httpService: HttpService) {
        this.API_URL = environment.apiUrl;
        this.ENV = environment.name;
    }

    isLoggedIn = false;
    userInfo: IUserInfo = new IUserInfo();
    loginUserSubject$: BehaviorSubject<IUserInfo>;
    redirectUrl: string;
    userRoles: string[];
    readOnly: boolean;
    secondApproval: boolean;

    initializeDataService(): void {
        this.loginUserSubject$ = new BehaviorSubject(new IUserInfo());
        if (this.userInfo.userId)
            this.loginUserSubject$.next(this.userInfo);
        else

            //TODO: Redirect to Error page to ask user to refresh the page.
            console.log('TODO: Redirect to Error page to ask user to refresh the page ');

    }
    subscribeToLoginService(): Observable<IUserInfo> {
        if (!this.loginUserSubject$)
            this.initializeDataService();
        return this.loginUserSubject$.asObservable();
    }

    login(): Observable<boolean> {
        try {
            if (window.location.href.includes('token')) {

                // Strip the leading '#' (and possible '/') so URLSearchParams parses keys correctly.
                // Without this, the first key would be "#id_token" instead of "id_token".
                var params = new URLSearchParams(window.location.hash.replace(/^#\/?/, ''));

                let idToken = params.get('id_token');
                let email = params.get('email');
                let roles = params.get('roles');
                this.readOnly = params.get('read_only') === 'True';
                this.secondApproval = params.get('second_approval') === 'True';
                this.userRoles = [roles];
                this._httpService.setToken(idToken);

                // Clean the hash so the Angular router doesn't try to match the token
                // params as a route path (which would hit the wildcard '**' → 404).
                // Use replaceState to avoid polluting browser history.
                window.history.replaceState(null, '', window.location.pathname + '#/');

                return this.getUserInfo(email);
            }
            return of(false);

        }

        catch (ex) {
            console.log('No User Info found, exception: >>> ' + ex);
            return of(true).pipe(tap(val => this.isLoggedIn = false));
        }
    }


    setToken(id_token: string): Observable<boolean> {
        if (id_token != null) {            
            return this._httpService.httpPost(this.API_URL + 'login/GenerateToken', null, null, id_token).pipe(
                map(res => res),
                tap(res => {
                    if (res != null) {
                        console.log(res.access_token);
                        this.userRoles = res.roles;
                        this._httpService.tokenAPI = res.access_token;
                    }
                }),
                catchError(error => {
                    console.error(error);
                    return throwError(() => "Unauthorized user");
                }),
                mergeMap(res => {
                    return this.getUserInfo(res.email);
                }));
        }
        else {
            localStorage.removeItem('userName');
            return of(true);
        }

    }


    getUserInfo(email: string): Observable<boolean> {

        let result = this._httpService.httpGet(this.API_URL + 'user/GetUser?email=' + email).pipe(
            map(res => res),
            tap(res => {
                if (res != null) {
                    let userData = this.toUserInfo(res);
                    let details = this.toAccessDetails(userData);

                    this.userInfo = userData;
                    this.accessDetails = details;

                    this.isLoggedIn = true;

                    // Notify subscribers that user info has been updated
                    if (this.loginUserSubject$) {
                        this.loginUserSubject$.next(this.userInfo);
                    }
                }
            }),
            map(() => true),
            catchError(err => {
                console.error('getUserInfo error:', err);
                return of(false);
            }));

        return result;
    }

    toUserInfo(r: any) {

        let userInfo = <IUserInfo>{
            accessToken: this._httpService.tokenAPI,
            email: r.Email,
            name: r.Name,
            phone: r.Phone,
            photoUrl: r.PhotoUrl,
            userId: r.UserId,
            userName: r.userName,
            lastLoginDate: r.LastLoginDate,
            role: this.userRoles
        };
        return userInfo;
    }

    toAccessDetails(r: any) {
        var details = <IAccess>({
            access_token: r.accessToken,
            userId: r.userId
        });
        return details;
    }

    isUserInRole(role: string): boolean {
        if (this.userInfo != null && this.userInfo.userId && this.userInfo.role) {
            return this.userInfo.role.find(x => x.toLowerCase() == role.toLowerCase()) != null;
        }
        return true;
    }

    error: any = null;
    private handleError(error: any) {
        this.error = error;
        return throwError(() => error || 'Server error');
    }



}


